import { defineStore } from 'pinia';
import {
  SMALLEST_BREAKPOINT,
  MIDDLE_BREAKPOINT,
  LARGEST_BREAKPOINT
} from '@/stores/constants.js';

export const useResponsiveBreakpointsStore = defineStore(
  'responsiveBreakpoints',
  {
    state: () => ({
      isBelowSmallestBreakpoint: window.innerWidth < SMALLEST_BREAKPOINT,
      isBelowMiddleBreakpoint: window.innerWidth < MIDDLE_BREAKPOINT,
      isBelowLargestBreakpoint: window.innerWidth < LARGEST_BREAKPOINT
    }),
    actions: {
      setIsBelowSmallestBreakpoint(isBelowSmallestBreakpoint) {
        this.isBelowSmallestBreakpoint = isBelowSmallestBreakpoint;
      },
      setIsBelowMiddleBreakpoint(isBelowMiddleBreakpoint) {
        this.isBelowMiddleBreakpoint = isBelowMiddleBreakpoint;
      },
      setIsBelowLargestBreakpoint(isBelowLargestBreakpoint) {
        this.isBelowLargestBreakpoint = isBelowLargestBreakpoint;
      }
    }
  }
);
